import React, { Component } from 'react';
import LegalMentions from '../results/LegalMentions';
import DisplayBlocks from '../results/DisplayBlocks';

class CalculatorContentCommon extends Component {
    render() {
        return (
            <React.Fragment>
                {this.props.isCalculationResult
                    && this.props.calculationResponse.result.globalText
                    && <div className="row p-1 m-1">
                        <LegalMentions data={this.props.calculationResponse.result.globalText} />
                    </div>
                }
            </React.Fragment>
        );
    }

    static renderDisplayBlocks(isCalculationResult, calculationResponse) {
        return (
            <React.Fragment>
                {isCalculationResult
                    && calculationResponse.result.displayBlocks != null
                    && <DisplayBlocks data={calculationResponse.result.displayBlocks} />
                }
            </React.Fragment>
        );
    }
}

export default (CalculatorContentCommon)
